import { render, staticRenderFns } from "./StoreBlock.vue?vue&type=template&id=f08d9094"
import script from "./StoreBlock.vue?vue&type=script&lang=js"
export * from "./StoreBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports